var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13.391,
    viewBox: "0 0 12 13.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secure",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change_password",
    "data-name": "Change password",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change_Password-2",
    "data-name": "Change Password"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 10.5,
    height: 8.332,
    rx: 1.7,
    transform: "translate(0 3.559)",
    fill: "none",
    stroke: "#778294",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5090",
    "data-name": "Group 5090",
    transform: "translate(2.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M13.683,5.459V3.824c0-1.063-1.229-1.924-2.745-1.924h-.892C8.529,1.9,7.3,2.761,7.3,3.824V5.459Z",
    transform: "translate(-7.3 -1.9)",
    fill: "none",
    stroke: "#778294",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(3.5 6.531)",
    fill: "#778294"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGrayIcon);
export default __webpack_public_path__ + "static/media/lock-gray-icon.97103a47fffd0baeaf15df3804e4a992.svg";
export { ForwardRef as ReactComponent };